<div class="video-image-container" [matTooltip]="toolTipText" matTooltipClass="error-tip">
    <img *ngIf="imgSource" [src]="imgSource" crossorigin="*" /> 
    <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
    <mat-icon *ngIf="noImage && !loading">broken_image</mat-icon>

		<div *ngIf="showPlayIcon && !loading" class="flex-row center-container play-icon-container">
			<mat-icon class="play-icon">play_arrow</mat-icon>
		</div>
</div>